export class User {
  id: number;
  uid: number;
  authUser?: {
    lastname?: string,
    motherlastname?: string,
    name?: string,
  };
  name: string;
  lastname: string;
  email: string;
  selected ? = false;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}

export class UserAuth {
  userid: number;
  name: String;
  lastname: String;
  motherlastname: String;
  username: String;
  email: String;
  selected: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/user.model.ts